import React, { useState } from "react";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { HiX } from "react-icons/hi";

/*  Our LOCAL component imports */
import FacetCheck from "../FacetCheck";

/*  Our GLOBAL component imports */
import { Chevron } from "../../../../Components/StudioIcons";
import { Divider } from "../../../../../../Components/Divider";
import { Footnote } from "../../../../../../Components/Text";
import { colors } from "../../../../../../../theme/colors";
import FacetPills from "../FacetPills";
import { useTranslation } from "react-i18next";

export default function StudioFacet({
  facet,
  onQuery,
  query,
  path,
  facetLoading,
}: any) {
  const { identifier, open, entries, showHeader, facetType } = facet;
  const selectedCount = query[identifier]?.length;
  const [isExpanded, setIsExpanded] = useState(selectedCount > 0 || open);
  const { t } = useTranslation("translation", { keyPrefix: "studioFacet" });
  if (!entries.length) {
    return <></>;
  }

  // ON Remix hide Games? temp just to see?

  if (path?.includes("remix") && identifier === "game") {
    return <></>;
  }

  return (
    <Box>
      <StyledFlex
        showHeader={showHeader}
        open={isExpanded}
        justifyContent="space-between"
        alignItems="center"
        onClick={() => {
          setIsExpanded(!isExpanded);
        }}
      >
        <StyledCategoryHeader
          alignItems="center"
          isExpanded={selectedCount}
          style={{
            color: isExpanded ? colors.ice : null,
          }}
        >
          {t(facet.label, { defaultValue: facet.label })}
          {selectedCount > 0 && (
            <SelectionBadge
              ml={2}
              onClick={(e) => {
                onQuery(false, identifier, "function-killAllIdentifiers");
                e.stopPropagation();
              }}
            >
              <StyledFootnote>
                <span style={{ color: "#F7FCFD" }}>{selectedCount}</span>
              </StyledFootnote>
              <SelectionBadgeClear />
            </SelectionBadge>
          )}
        </StyledCategoryHeader>
        <Chevron alignSelf="flex-end" isexpanded={isExpanded} />
      </StyledFlex>

      <Flex
        flexDirection="column"
        style={{
          display: isExpanded ? undefined : "none",
          margin: "5px auto",
        }}
      >
        {entries.map((x: any) => {
          if (facetType === "list") {
            return (
              <FacetCheck
                key={JSON.stringify(x)}
                item={x}
                identifier={identifier}
                onQuery={onQuery}
                query={query}
                facetLoading={facetLoading}
              />
            );
          } else return <></>;
        })}
      </Flex>

      <Flex
        flexDirection="row"
        flexWrap="wrap"
        style={{
          display: isExpanded ? undefined : "none",
        }}
      >
        {entries.map((x: any) => {
          if (facetType === "pills") {
            return (
              <FacetPills
                key={JSON.stringify(x)}
                item={x}
                identifier={identifier}
                onQuery={onQuery}
                query={query}
                facetLoading={facetLoading}
              />
            );
          } else return <></>;
        })}
      </Flex>

      <Divider />
    </Box>
  );
}

const StyledFlex = styled(Flex)<any>`
  display: ${(props) => (props.showHeader ? "" : "none")};
  &:hover {
    color: ${(props) => props.theme.colors.ice};
  }
  &:hover ${Chevron} {
    color: ${(props) => props.theme.colors.ice};
  }
`;

const StyledFootnote = styled(Footnote)`
  font-weight: 600;
  line-height: 1.6em;
  color: ${(props) => props.theme.colors.ice};
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
`;

const StyledCategoryHeader = styled(Flex)<any>`
  gap: 5px;
  height: 36px;
  margin-bottom: 0px;
  color: ${(props: any) => (props.isExpanded ? props.theme.colors.ice : null)};
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
  font-size: 12px;
`;

const SelectionBadgeClear = styled(HiX)`
  width: 10px;
  height: 10px;
  padding: 2px;
  border-radius: 50%;
  cursor: inherit;
  margin-left: 6px;
  margin-right: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: inherit;
  background: #7a9dd2;
`;

const SelectionBadge = styled(Flex)`
  margin-right: 10px;
  border-radius: 999px;
  color: ${(props) => props.theme.colors.ice};
  background: #4f6a89;
  padding: 2px 2px 2px 10px;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
  transition: 0.2s;
  border-color: #7a9dd2;
  &:hover {
    background: #774054;
    border-color: ${(props) => props.theme.colors.alert};
    color: ${(props) => props.theme.colors.ice};
  }
  &:hover ${SelectionBadgeClear} {
    background: ${(props) => props.theme.colors.alert};
  }
`;
